module.exports = __webpack_public_path__ + "static/flags/GA-62d6b94a6375fbf0f8752c7da34a0309.gif";